var _defs, _circle, _path, _circle2, _polygon, _path2, _polygon2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnDepositSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "return_deposit",
    "data-name": "return deposit",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297.9 291.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#ea9c2e;}.cls-2{fill:#fff;}.cls-2,.cls-4,.cls-5{fill-rule:evenodd;}.cls-3,.cls-5{fill:none;stroke:#eb9c2c;stroke-miterlimit:10;}.cls-3{stroke-width:4px;stroke-dasharray:24.73 19.78 24.73 24.73 19.78 24.73;}.cls-5{stroke-width:6.4px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 152.45,
    cy: 145.79,
    r: 63.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.55,166h0a7.89,7.89,0,0,0-2.3-5.7V160h0v-.25H160v-.24h-.24v-.25a34.83,34.83,0,0,0-6.27-3.17c-6.73-2.42-11.5-4.85-14.52-7.81-3.26-2.95-4.81-6.91-4.87-12.14s1.41-9.24,4.6-12.26c2.95-3.27,7.16-5,12.38-5.86l-.1-9.47,7.22-.08.11,9.72c5.24.69,9.24,2.63,12.27,6.34,3,3.45,4.58,8.41,4.39,13.89v.25l-12.7.14c0-3.49-.81-6.22-2.33-8.19a6.74,6.74,0,0,0-5.76-2.67,6.59,6.59,0,0,0-2.23.27h-.5v.25h-.5v.25h-.74V129h-.25v.25h-.24v.25h-.5v.25H149V130h-.25v.24h-.25v.5H148v.5h-.25V132h-.24v.25h-.25v1H147v.5a7.17,7.17,0,0,0-.21,2.25,8.9,8.9,0,0,0,2.05,5.7c1.25,1.23,3.76,2.45,7.26,3.9,6.5,2.42,11.26,5.11,14.54,8.31,3,2.71,4.81,6.67,4.87,11.9.05,5-1.64,9.23-4.61,12A20.2,20.2,0,0,1,158,183.7l.1,8.7-6.73.08-.09-8.71a23.74,23.74,0,0,1-14-5.57c-3.52-3.46-5.31-8.41-5.39-14.89l.25-.25,12.7-.14c0,4.23,1.06,6.71,2.58,8.69,2,1.72,4,2.19,7,2.16,2.49,0,4-.3,5.46-1.31h.24v-.25h.25V172h0v-.25a7.88,7.88,0,0,0,2.18-5.75Z",
    transform: "translate(-1.1 -4.7)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 152.45,
    cy: 145.79,
    r: 88.16
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "270.91 96.28 256.62 99.89 271.06 115.25 285.91 130.5 292.1 109.93 297.9 89.45 283.61 93.07 270.91 96.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M7.3,147.93a140,140,0,0,1,275-37.44",
    transform: "translate(-1.1 -4.7)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27 195.22 41.3 191.61 26.86 176.25 12.02 160.99 5.82 181.56 0 202.03 14.29 198.42 27 195.22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.83,153.14a141.73,141.73,0,0,1-2.11,24.28,140.06,140.06,0,0,1-272.9,13",
    transform: "translate(-1.1 -4.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnDepositSelected);
export default __webpack_public_path__ + "static/media/return-deposit-selected.b7bff8b0b75618c419ee204686fdfce9.svg";
export { ForwardRef as ReactComponent };